import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [unread, setUnread] = useState(0);

  const refreshUnread = useCallback(async () => {
    try {
      const r = await api.get("/notifications/count");
      setUnread(r.data.unread);
    } catch {
      // background polling: keep the last known count, next tick will retry
      return;
    }
  }, []);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (!user) return;
    api.get("/notifications").then((r) => setUnread(r.data.unread)).catch(() => setUnread(0));
    const t = setInterval(refreshUnread, 60000);
    return () => clearInterval(t);
  }, [user, refreshUnread]);

  const login = useCallback(async (email, password) => {
    await api.post("/auth/login", { email, password });
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  }, []);
  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      toast.error("Disconnessione dal server non riuscita: sessione chiusa solo su questo dispositivo");
    }
    setUser(false);
  }, []);
  const value = useMemo(
    () => ({ user, setUser, login, logout, unread, setUnread, refreshUnread }),
    [user, login, logout, unread, refreshUnread]
  );
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
